import request from "../Config/axios";
// -----------------------------------------------------------
export const GetAll_Paging_ParkingPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/ParkingPricePeriod/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Add_ParkingPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/ParkingPricePeriod/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_ParkingPricePeriod_Api = async (id) => {
    const { data } = await request.get(
        `/ParkingPricePeriod/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_ParkingPricePeriod_Api = async (params) => {
    const { data } = await request.post(
        `/ParkingPricePeriod/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_ParkingPricePeriod_Api = async (id) => {
    const { data } = await request.delete(
        `/ParkingPricePeriod/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
